import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./bottomsheet.module.css";
import clsx from "clsx";
import BottomSheetModal from "../../BottomSheetModal";
import { ReactComponent as GuideIcon } from "../../../assets/quick-guide-without-bg-icon.svg";
import ImageComponent from "../../ImageComponent";
import { useSelector } from "react-redux";
import { getQuickGuide } from "../store/actions";
import { IQuickGuideItem, IQuickGuideRow } from "../../../pages/GamePlay/types";

interface QuickGuideItem {
  cardHeading: string;
  items: { icon: React.ReactNode; itemContent: string }[];
}

interface QuickGuideBottomsheetInterface {
  isOpen: boolean;
  onClose: () => void;
}

const QuickGuideBottomsheet: React.FC<QuickGuideBottomsheetInterface> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const quickGuide = useSelector(getQuickGuide);

  // const quickGuideItems: QuickGuideItem[] = [
  //   {
  //     cardHeading: "GAME RULES",
  //     items: [
  //       {
  //         icon: "https://assets.zupee.com/nx/assets/img/game_quick_quide_1.png",
  //         itemContent: "All players get 36 moves and an equal number of 1s, 2s, 3s, 4s, 5s & 6s on the dice",
  //       },
  //       {
  //         icon: "https://assets.zupee.com/nx/assets/img/game_quick_quide_2.png",
  //         itemContent: "1 box moved = 1 point",
  //       },
  //       {
  //         icon: "https://assets.zupee.com/nx/assets/img/game_quick_quide_3.png",
  //         itemContent: "Extra 60-seconds Timebank for every game. Game ends if Timebank runs out",
  //       },
  //     ],
  //   },
  //   {
  //     cardHeading: "SCORING SYSTEM",
  //     items: [
  //       {
  //         icon: "https://assets.zupee.com/nx/assets/img/game_quick_quide_4.png",
  //         itemContent: "Cut tokens to collect points they carry and get 1 extra move. Tap on tokens to see their value.",
  //       },
  //       {
  //         icon: "https://assets.zupee.com/nx/assets/img/game_quick_quide_5.png",
  //         itemContent: "Token reached Home = 1 extra move",
  //       },
  //     ],
  //   },
  //   {
  //     cardHeading: "LEAGUE DETAILS",
  //     items: [
  //       {
  //         icon: "https://assets.zupee.com/nx/assets/img/game_quick_quide_6.png",
  //         itemContent: "Single Player Game with no other opponents on the board",
  //       },
  //       {
  //         icon: "https://assets.zupee.com/nx/assets/img/game_quick_quide_7.png",
  //         itemContent: "Compete against the scores of other players",
  //       },
  //       {
  //         icon: "https://assets.zupee.com/nx/assets/img/game_quick_quide_8.png",
  //         itemContent: "Play multiple times to retry for a better score",
  //       },
  //       {
  //         icon: "https://assets.zupee.com/nx/assets/img/game_quick_quide_9.png",
  //         itemContent: "Score higher to earn top positions on the leaderboard and win",
  //       },
  //     ],
  //   },
  // ];

  return (
    <BottomSheetModal
      isOpen={isOpen}
      onClose={onClose}
      modalContentClassName={clsx(styles.modalContent, "bgWhite")}
      modalBodyClassName={clsx(styles.modalBody)}
      content={
        <>
          <div className={clsx(styles.modalHeadingContent)}>
            <div
              className={clsx(
                styles.modalTitleBlock,
                styles.prizePoolBlock,
                "inlineFlex alignItemCenter justifyContentCenter"
              )}
            >
              <GuideIcon />
              <span
                className={clsx(
                  styles.label,
                  "fontWeightBold fontSizeSm14 fontColorLightBlue"
                )}
              >
                {t("quickGuide")}
              </span>
            </div>
          </div>
          <div className={clsx(styles.modalBodyContent, styles.quickGuideModalBody)}>
            {quickGuide?.map((item: IQuickGuideItem, cardIndex: number) => (
              <div className={clsx(styles.quickGuideCard)} key={cardIndex}>
                <div
                  className={clsx(
                    styles.cardHeading,
                    "fontSizeSm14 fontColorLightBlue textAlignCenter fontWeightBolder flex alignItemCenter justifyContentCenter"
                  )}
                >
                  {item.title}
                </div>
                {item.rows?.map((row: IQuickGuideRow, itemIndex: number) => (
                  <div className={clsx(styles.cardRow, "flex alignItemCenter justifyContentFS")} key={itemIndex}>
                    <ImageComponent 
                      className={clsx(styles.cardColItem, styles.cardIcon)}
                      src={row.image || ''}
                      alt={row.text || ''}
                    />
                    <div className={clsx(styles.cardColItem, styles.itemContent, "fontSizeSm14 fontColorLightBlue fontWeightMedium textAlignLeft")}>
                      {row.text}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </>
      }
    />
  );
};

export default QuickGuideBottomsheet;
